<p>
    <img src="./assets/temporals/red-warning.png" alt="">
</p>
<p>
    {{data.text}}
</p>
<div class="btn-container" *ngIf="!data.hideAccept">
    <button type="submit" (click)="closeModal()"  id="closeWarningLogin" class="button">Aceptar</button>
</div>